import { Injectable, Type } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { BehaviorSubject, Subject } from 'rxjs';
import { BottomSheetReturnType } from './bottom-sheet-return-type.enum';
import { BottomSheetReturn } from './bottom-sheet-return.model';

export interface OpenBottomSheetOptions<T = any> {
    args?: T;
    submitButtonText?: string | null;
    secondaryButtonText?: string | null;
    maxWidth?: string;
    maxHeight?: string;
}


@Injectable({ providedIn: 'root' })
export class BottomSheetService<T> {

    public component!: Type<any>;
    public sheetTitle = "";
    public show: boolean = false;
    public displayed$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public submitButtonEnabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public closeButtonEnabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public submit$: Subject<BottomSheetReturn<T>> = new Subject();
    public args: any;
    public submitButtonText: string | null = null;
    public secondaryButtonText: string | null = null;
    public message$: BehaviorSubject<SafeHtml> = new BehaviorSubject<SafeHtml>("");
    public maxWidth: string = "38rem";
    public maxHeight: string = "85%";
    public opened$: BehaviorSubject<string> = new BehaviorSubject<string>('')

    constructor() {
    }

    public openBottomSheet<TComponent, TArgs>(
        component: Type<TComponent>,
        title: string,
        options: OpenBottomSheetOptions<TArgs> = {},
    ) {
        if (this.displayed$.value) return;

        const defaults: Required<OpenBottomSheetOptions<TArgs>> = {
            args: {} as TArgs,
            submitButtonText: null,
            secondaryButtonText: null,
            maxWidth: '38rem',
            maxHeight: '85%',
        };

        const merged = { ...defaults, ...options };

        this.submitButtonText = merged.submitButtonText;
        this.secondaryButtonText = merged.secondaryButtonText;
        this.sheetTitle = title;
        this.args = merged.args;
        this.maxWidth = merged.maxWidth;
        this.maxHeight = merged.maxHeight;
        this.component = component;

        this.opened$.next(title);
        this.displayed$.next(true);
    }

    public closeBottomSheet() {

        this.submit$.next({ value: null, type: BottomSheetReturnType.CANCEL })
        this.submit$.complete()
        this.submit$ = new Subject()
        this.closeButtonEnabled$.next(true);
        this.message$.next('')
        this.submitButtonEnabled$.next(false);

        this.show = false
        setTimeout(() => {
            this.displayed$.next(false);
        }, 250)
    }

}
